

export default function ShowTotalBudget({ budget }) {

	return (
		<div className='total-budget-container'>
			<div className='operation'>
				<div>
					<span className='budget-text'>Total Operations Hours:</span> {`${budget?.operationsBudgetTotalHours}`}
				</div>
				<div>
					<span className='budget-text'>Total Operations Cost:</span> {`${budget?.operationsBudgetTotalCost?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
				</div>
			</div>
			<div className='research'>
				<div>
					<span className='budget-text'>Total Research Hours:</span> {`${budget?.researchBudgetTotalHours}`}
				</div>
				<div>
					<span className='budget-text'>Total Research Cost:</span> {`${budget?.researchBudgetTotalCost?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
				</div>
			</div>
			<div className='material'>
				<div>
					<span className='budget-text'>Total Material Cost:</span> {`${budget?.materialsBudgetTotal?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
				</div>
			</div>
		</div>
	)
}